"use client";

/**
 * ValentinesBackground
 *
 * Background decorations for Valentines theme.
 * Part of the decoration system - controlled via NEXT_PUBLIC_ACTIVE_DECORATIONS.
 *
 * Fixed-position side decorations centered vertically on the left and right edges.
 */
export function ValentinesBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none select-none">
      {/* Left side */}
      <img
        src="/images/decorations/valentines/valentines-left.webp"
        alt=""
        loading="lazy"
        decoding="async"
        className="fixed top-1/2 left-2 -translate-y-1/2 hidden xl:block z-0 h-[70vh] w-auto max-h-[80vh]"
      />

      {/* Right side */}
      <img
        src="/images/decorations/valentines/valentines-right.webp"
        alt=""
        loading="lazy"
        decoding="async"
        className="fixed top-1/2 right-2 -translate-y-1/2 hidden xl:block z-0 h-[70vh] w-auto max-h-[80vh]"
      />
    </div>
  );
}
